var GdsButtonTarget;
(function (GdsButtonTarget) {
  GdsButtonTarget["blank"] = "_blank";
  GdsButtonTarget["self"] = "_self";
  GdsButtonTarget["parent"] = "_parent";
  GdsButtonTarget["top"] = "_top";
  GdsButtonTarget["modal"] = "modal";
  GdsButtonTarget["fullScreenModal"] = "fullScreenModal";
  GdsButtonTarget["routeLink"] = "routeLink";
  GdsButtonTarget["download"] = "download";
  GdsButtonTarget["youtube"] = "youtube";
  GdsButtonTarget["openFilter"] = "open-filter";
  GdsButtonTarget["clearFilter"] = "clear-filter";
  GdsButtonTarget["search"] = "search";
  GdsButtonTarget["parkHoursDropdown"] = "park-hours-dropdown";
  GdsButtonTarget["privacy"] = "privacy";
  GdsButtonTarget["mapModal"] = "map-modal";
})(GdsButtonTarget || (GdsButtonTarget = {}));

export { GdsButtonTarget as G };

